<template>
<div>
  <h2>uashuihduiasidhaishldhaishifgauif</h2>
</div>
</template>

<script>
  export default {
     name: 'Property_Data',
     data () {
       return {
          
        };
     },
     methods: {
    
     }
   }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Property/Property_Data.vue